/**
 * セレクトの値をセットする
 * @param {*} elm
 * @param {*} find
 * @param {*} datas
 * @param {*} callback
 */
exports.set_select = function (elm, find, datas = {}, callback = null) {
    let select = $(elm).parents('form').find(find);
    if (select.length > 0) {
        let action = $(select).data('action');
        let value = $(select).val();
        if (find == 'select.account-user-select') {
            datas.selected = value;
        }
        _ajax.post(action, datas, function (results) {
            $(select).empty();
            $(select).select2({
                width: "100%", 
                data: results.options, 
                val: value
            });
            $(select).val(value).trigger('change');
            if (callback != null) {
                callback(elm);
            }
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    }
};